import { isMobile } from './browser';

const getEventType = e => {
  if (
    e.type === 'touchstart' ||
    e.type === 'touchmove' ||
    e.type === 'touchend' ||
    e.type === 'touchcancel'
  ) {
    return 'touch';
  } else if (
    e.type === 'mousedown' ||
    e.type === 'mouseup' ||
    e.type === 'mousemove' ||
    e.type === 'mouseover' ||
    e.type === 'mouseout' ||
    e.type === 'mouseenter' ||
    e.type === 'mouseleave'
  ) {
    return 'mouse';
  }
  return null;
};

export const MOUSE_START = isMobile() ? 'touchstart' : 'mousedown';
export const MOUSE_MOVE = isMobile() ? 'touchmove' : 'mousemove';
export const MOUSE_END = isMobile() ? 'touchend' : 'mouseup';
export const getClientX = e => {
  if (getEventType(e) === 'touch') {
    const touch = e.touches[0] || e.changedTouches[0];
    return touch.clientX;
  }
  return e.clientX;
};



// WEBPACK FOOTER //
// ./src/utils/mouse.ts